var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import TextAccentRed from "./textAccentRed";
import TextArticle from "./textArticle";
import TextArticleSmall from "./textArticleSmall";
import TextHtml from "./textHtml";
import TextItalic from "./textItalic";
import TextMeta from "./textMeta";
import TextUppercase from "./textUppercase";
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Text.AccentRed = TextAccentRed;
    Text.Article = TextArticle;
    Text.ArticleSmall = TextArticleSmall;
    Text.Html = TextHtml;
    Text.Italic = TextItalic;
    Text.Meta = TextMeta;
    Text.Uppercase = TextUppercase;
    return Text;
}(React.Component));
export default Text;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/text/text.tsx
// module id = AEBA
// module chunks = 2